import React, { useState, useRef, useEffect } from "react";
import { getTrans as t } from "../../../../Localization/translations";
import Tooltip from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import axios from "axios";
import CheckButton from "react-validation/build/button";
import Form from "react-validation/build/form";
import { useForm } from "react-hook-form";
import { confirmAlert } from "react-confirm-alert";
import { ToastContainer, toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";

import AddPartyNotificationService from "../../../../services/party/notification/addNotificationService";
import ButtonLoading from "../../../../components/Loder/buttonLoading";
import EditNotificationService from "../../../../services/party/notification/editNotificationService";
import { API } from "../../../../backend";
import authHeader from "../../../../services/auth-header";

function AddNotification({
  id,
  contactemail = null,
  setnotificationId,
  notification = null,
  setTab = null,
  setHideShowNotify
}) {
  const [notification_reminder, setNotification_reminder] =
    useState("Due Date Reminder");
  const [notification_type, setNotification_type] = useState("Email");
  const [notification_days, setNotification_days] = useState(30);
  const [to_email, setTo_email] = useState("");
  const [enable, setEnable] = useState(1);

  const [successful, setSuccessful] = useState(false);
  const [loading, setLoading] = useState(false);
  const [disable, setDisable] = useState(false);

  let navigate = useNavigate();
  const checkBtn = useRef();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const form = useRef();

  const location = useLocation();
  const data = location.state?.party_id;

  const handleCancel = () => {
    if (setTab) {
      navigate("/party/details", { state: id });
    } else {
      // setHideShow(true);
      setHideShowNotify(false)
    }
  };

  const handleRegister = () => {
    if (notification !== null) {
      handleUpdateNotification();
    } else {
      setSuccessful(false);
      setLoading(true);
      setDisable(true);
      form.current.validateAll();
      if (checkBtn.current.context._errors.length === 0) {
        if (id !== null) {
          id = id;
        } else {
          id = data;
        }
        AddPartyNotificationService.addPartyNotification(
          id,
          notification_reminder,
          notification_type,
          notification_days,
          to_email,
          enable
        ).then((response) => {
          if (response.data.success) {
            setSuccessful(true);
            setLoading(false);
            setTimeout(() => {
              if (setTab) {
                setnotificationId(response.data.notificationId);
                setTab(3);
              } else {
                // setHideShow(true);
                setHideShowNotify(false)
              }
            }, 2000);
            toast.success(`${response.data.response}`, {
              position: "top-right",
              autoClose: 1000,
              hideProgressBar: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
          } else {
            toast.error(`${response.data.error}`, {
              position: "top-right",
              autoClose: 1000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
            setSuccessful(false);
            setDisable(false);
          }
        })
      }
    }
  };

  const invoice_number_method = async () => {
    const responseJSON = await axios
      .get(API + `billing/invoice_number_method/`, { headers: authHeader() })
      .then((response) => {
        if (response.data.success === 1) {
          setNotification_days(response.data.past_due_bucket);
          reset({
            notification_days: response.data.past_due_bucket,
          });
        } else {
          confirmAlert({
            title: "",
            message: "Go to settings and update Invoice Past Due Bucket.",
            buttons: [
              {
                label: "OK",
                onClick: () => navigate("/additionalsettings"),
              },
            ],
          });
        }
      })
  };

  useEffect(() => {
    // if (selectedValue2 !== null) {
    //   getAddress();
    // }
    invoice_number_method();
  }, []);

  const handleUpdateNotification = () => {
    setSuccessful(false);
    setLoading(true);
    form.current.validateAll();
    if (checkBtn.current.context._errors.length === 0) {
      EditNotificationService.editPartyNotificationDetails(
        notification,
        notification_reminder,
        notification_type,
        notification_days,
        to_email,
        enable
      ).then((response) => {
        if (response.data.success) {
          setSuccessful(true);
          setLoading(false);
          toast.success(`${response.data.response}`, {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else {
          toast.error(`${response.data.error}`, {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setSuccessful(false);
        }
      })
    }
  };

  useEffect(() => {
    if (notification !== null) {
      EditNotificationService.getPartyNotificationDetails(notification).then(
        (response) => {
          setNotification_reminder(response.data.notification_reminder);
          setNotification_type(response.data.notification_type);
          setNotification_days(response.data.notification_days);
          if (contactemail !== null) {
            setTo_email(contactemail);
          } else {
            setTo_email(response.data.to_email);
          }
          setEnable(response.data.enable);

          reset({
            notification_reminder: response.data.notification_reminder,
            notification_type: response.data.notification_type,
            notification_days: response.data.notification_days,
            to_email: response.data.to_email,
            enable: response.data.enable,
          });
        }
      )
    }
    if (contactemail !== null) {
      setTo_email(contactemail);
      reset({
        to_email: contactemail,
      });
    }
  }, [contactemail, notification, reset]);

  return (
    <>
      <div className="container-fluid">
        <ToastContainer />
        <div className="header mb-3">
          <h5 className="modal-title text-left">
            {t("Notification Settings")}
          </h5>
        </div>
        <div className="card" role="document">
          <div className="card-body">
            <div className="row">
              <div className="col-md-12">
                <Form
                  role="form text-left"
                  onSubmit={handleSubmit(handleRegister)}
                  ref={form}
                  action="."
                  method="POST"
                  id="addPartyContactForm"
                >
                  {
                    <>
                      <div className="form-group row">
                        <div className="col-md-3">
                          <label className="col-form-label required">
                            {t("Notification")}{" "}
                            <Tooltip content={t("Notification_Tooltip")}>
                              <i className="fa fa-light fa-circle-info"></i>
                            </Tooltip>
                          </label>
                          <select
                            className="form-control form-select"
                            name="notification_reminder"
                            id="id_notification"
                            value={notification_reminder}
                            {...register("notification_reminder", {
                              onChange: (e) => {
                                setNotification_reminder(e.target.value);
                              },
                              required: true,
                            })}
                          >
                            <option value="" selected="">
                              {t("Select Notification Reminder ")}
                            </option>
                            <option value="Due Date Reminder">
                              {t("Due Date Reminder")}
                            </option>
                            <option value="Email Invoice">
                              {t("Email Invoice")}
                            </option>
                            <option value="Past Due">{t("Past Due")}</option>
                          </select>
                          <div className="invalid-feedback">
                            {errors.notification_reminder?.type ===
                              "required" &&
                              "Notification Reminder is required"}
                          </div>
                        </div>
                        <div className="col-md-3">
                          <label className="col-form-label required">
                            {t("Type")}{" "}
                            <Tooltip content={t("Type_Tooltip")}>
                              <i className="fa fa-light fa-circle-info"></i>
                            </Tooltip>
                          </label>
                          <select
                            className="form-control form-select"
                            name="notification_type"
                            id="id_notification"
                            value={notification_type}
                            {...register("notification_type", {
                              onChange: (e) => {
                                setNotification_type(e.target.value);
                              },
                              required: true,
                            })}
                          >
                            <option value="" selected="">
                              {t("Select Notification Type")}
                            </option>
                            <option value="Email">{t("Email")}</option>
                          </select>
                          <div className="invalid-feedback">
                            {errors.notification_type?.type === "required" &&
                              "Notification Type is required"}
                          </div>
                        </div>
                        {
                          notification_reminder !== "Email Invoice" &&
                          <div className="col-md-3">
                            <label className="col-form-label required">
                              {notification_reminder === 'Past Due' ? t("Days Past Due") : t("Days In Advance")}
                              {/* {t("Days In Advance")}{" "} */}
                              <Tooltip content={notification_reminder === 'Past Due' ? t("DaysPastDue_Tooltip") : t("DaysInAdvance_Tooltip")}>
                                <i className="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label>
                            <input
                              value={notification_days}
                              type="number"
                              name="notification_days"
                              className="form-control no-spinner"
                              id="notification_days"
                              placeholder={notification_reminder === 'Past Due' ? t("Days Past Due") : t("Days In Advance")}
                              // disabled
                              {...register("notification_days", {
                                validate: {
                                  positive: (v) =>
                                    parseInt(v) > -1 ||
                                    "Enter Notification Days Positive Value",
                                },
                                onChange: (e) => {
                                  setNotification_days(e.target.value);
                                },
                                required: "Notification Days is required",
                              })}
                            />
                            <div className="invalid-feedback">
                              {errors.notification_days?.message}
                            </div>
                          </div>
                        }
                        <div className="col-md-3">
                          <label className="col-form-label required">
                            {t("To")}{" "}
                            <Tooltip content={t("To_Tooltip")}>
                              <i className="fa fa-light fa-circle-info"></i>
                            </Tooltip>
                          </label>
                          <input
                            value={to_email}
                            type="email"
                            name="to_email"
                            className="form-control"
                            id="to_email"
                            placeholder="Enter Email"
                            {...register("to_email", {
                              onChange: (e) => {
                                setTo_email(e.target.value);
                              },
                              required: true,
                            })}
                          />
                          <div className="invalid-feedback">
                            {errors.to_email?.type === "required" &&
                              "Email is required"}
                          </div>
                        </div>
                        <div className="col-md-4">
                          <label className="col-form-label">
                            {t("Enable")}{" "}
                            <Tooltip content={t("Enable_Tooltip")}>
                              <i className="fa fa-light fa-circle-info"></i>
                            </Tooltip>
                          </label>
                          <div className="form-group row">
                            <div
                              className="form-check"
                              style={{ width: "50%", paddingLeft: "3em" }}
                            >
                              <input
                                checked={String(enable) === "1"}
                                className="form-check-input"
                                value="1"
                                type="radio"
                                name="enable"
                                id="flexRadioDefault1"
                                {...register("enable", {
                                  onChange: (e) => {
                                    setEnable(e.target.value);
                                  },
                                  required: false,
                                })}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="flexRadioDefault1"
                              >
                                Yes
                              </label>
                            </div>
                            <div
                              className="form-check"
                              style={{ width: "50%", paddingLeft: "3em" }}
                            >
                              <input
                                className="form-check-input"
                                checked={String(enable) === "0"}
                                value="0"
                                type="radio"
                                name="enable"
                                id="flexRadioDefault2"
                                {...register("enable", {
                                  onChange: (e) => {
                                    setEnable(e.target.value);
                                  },
                                  required: false,
                                })}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="flexRadioDefault2"
                              >
                                No
                              </label>
                            </div>
                          </div>
                          <div className="invalid-feedback">
                            {errors.enable?.type === "required" &&
                              "Enable is required"}
                          </div>
                        </div>
                      </div>
                      <div className="text-left py-3">
                        <button
                          type="button"
                          className="btn btn-secondary btn-md"
                          data-bs-dismiss="modal"
                          onClick={handleCancel}
                        >
                          {t("Cancel")}
                        </button>
                        &nbsp;&nbsp;
                        <button
                          type="submit"
                          disabled={disable}
                          className="border-0 btn btn-primary btn-gradient-primary btn-md"
                        >
                          {loading === false ? (
                            // t("Save & Continue")
                            t("Save")
                          ) : (
                            <ButtonLoading />
                          )}
                        </button>
                      </div>
                    </>
                  }
                  <CheckButton style={{ display: "none" }} ref={checkBtn} />
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddNotification;
